module.exports = __webpack_public_path__ + "img/calendar.f5147e39.svg";